<template>
  <div id="topo">

    <z-centralized-toolbar>
      <v-btn text color="primary" :to="{ name: 'NotasFiscaisLista' }" exact>
        <v-icon left>mdi-arrow-left</v-icon>
        Voltar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn text @click="$router.push({ name: 'NotasFiscaisLista' })" :disabled="emitindo || salvando">Cancelar</v-btn>
      <v-btn class="ml-3" color="primary" @click="salvarNFSE" :loading="emitindo || salvando" :disabled="emitindo || salvando">Salvar</v-btn>

      <v-divider vertical class="mx-3"></v-divider>

      <v-btn color="primary" @click="emitirNFSE" :loading="emitindo" :disabled="emitindo || salvando">Emitir</v-btn>
    </z-centralized-toolbar>

    <v-divider></v-divider>


    <v-expand-transition>
      <z-container v-show="exibir_alerta_formulario && !form_valido" bottom="0px">
        <v-alert
        border="left"
        color="red"
        elevation="4"
        text
        type="error"
        >Verifique os dados do formulário.</v-alert>
      </z-container>
    </v-expand-transition>

    <z-loading :loading="loadingList" height="100vh" color="indigo"></z-loading>

    <v-form v-model="form_valido" ref="form" lazy-validation>

      <z-container v-show="!loadingList">

        <z-status-nfse
          :situacao="nfse.rps_situacao"
          class="mb-3"
        >Aguardando</z-status-nfse>


        <v-card class="mb-5">
          <v-tabs v-model="tabAtiva">
            <v-tab>
              Emitente
            </v-tab>
            <v-tab>
              Tomador
            </v-tab>
            <v-tab>
              Competência e Local
            </v-tab>
            <v-tab>
              Serviço
            </v-tab>
            <v-tab>
              Valores
            </v-tab>
            <v-tab>
              Impostos Federais
            </v-tab>
            <v-tabs-slider color="primary"></v-tabs-slider>
          </v-tabs>

          <v-divider></v-divider>

          <v-tabs-items v-model="tabAtiva">
            <!-- Tab 0: Emitente -->
            <v-tab-item eager>
              <v-card flat>
                <v-card-text>
                  <v-row dense>
                    <v-col sm="9">
                      <z-text-field
                        v-model="nfse.emitente_razao_social"
                        label="Emitente Razão Social"
                        readonly
                      ></z-text-field>
                    </v-col>
                    <v-col sm="3">
                      <z-cpf-cnpj
                        label="CPF/CNPJ"
                        readonly
                        hide-details
                        :value="nfse.emitente_cnpj"
                      ></z-cpf-cnpj>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

            </v-tab-item>

            <!-- Tab 1: Tomador -->
            <v-tab-item eager>
              <v-card tile>
                <v-card-text>
                  <v-row dense>

                    <v-col sm="3">
                      <!-- <v-text-field label="CPF/CNPJ" v-model="nfse.tomador.cpfcnpj" :readonly="!isNotaAvulsa" :rules="[regras.obrigatorio]" return-masked-value></v-text-field> -->
                      <z-cpf-cnpj
                        label="CPF/CNPJ"
                        v-model="nfse.tomador.cpfcnpj"
                        append-icon="mdi-magnify"
                        :rules="[regras.obrigatorio]"
                        @keyup="buscarTomador"
                        @click:append="$refs.DialogoBuscarClientes.abrir()"
                      ></z-cpf-cnpj>
                    </v-col>

                    <v-col sm="9">
                      <z-text-field
                        v-model="nfse.tomador.razao_social"
                        label="Razão Social"
                        readonly
                        :rules="[regras.obrigatorio]"
                      >
                        <template #append v-if="nfse.tomador.id">
                          <v-btn
                            small
                            depressed
                            color="primary"
                            target="_blank"
                            :to="{ name: 'ClientesEditar', params: { id: nfse.tomador.id } }"
                          >Editar</v-btn>
                        </template>
                      </z-text-field>
                    </v-col>

                    <v-col sm="4">
                      <z-text-field
                        v-model="nfse.tomador.cep"
                        readonly
                        label="CEP"
                        :rules="[regras.obrigatorio]"
                      ></z-text-field>
                    </v-col>

                    <v-col sm="4">
                      <z-select
                        v-model="nfse.tomador.uf"
                        :items="estados"
                        label="Estado"
                        readonly
                        :rules="[regras.obrigatorio]"
                      ></z-select>
                    </v-col>

                    <v-col sm="4">
                      <z-autocomplete
                        v-model="nfse.tomador.codigo_municipio"
                        label="Cidade"
                        readonly
                        :items="getCidadesByUF(nfse.tomador.uf)"
                        :rules="[regras.obrigatorio]"
                      ></z-autocomplete>
                    </v-col>

                    <v-col sm="9">
                      <z-text-field
                        label="Endereço"
                        v-model="nfse.tomador.endereco"
                        readonly
                        :rules="[regras.obrigatorio]"
                      ></z-text-field>
                    </v-col>

                    <v-col sm="3">
                      <z-text-field
                        label="Número"
                        v-model="nfse.tomador.numero"
                        readonly
                        :rules="[regras.obrigatorio]"
                      ></z-text-field>
                    </v-col>

                    <v-col sm="6">
                      <z-text-field
                        label="Bairro"
                        v-model="nfse.tomador.bairro"
                        readonly
                        :rules="[regras.obrigatorio]"
                      ></z-text-field>
                    </v-col>

                    <v-col sm="6">
                      <z-text-field
                        v-model="nfse.tomador.complemento"
                        label="Complemento"
                        readonly
                      ></z-text-field>
                    </v-col>

                    <v-col sm="4">
                      <z-text-field
                        v-model="nfse.tomador.email"
                        label="Email"
                        readonly
                      ></z-text-field>
                    </v-col>

                    <v-col sm="2">
                      <z-text-field
                        v-model="nfse.tomador.telefone"
                        label="Telefone"
                        readonly
                      ></z-text-field>
                    </v-col>


                    <v-col sm="2">
                      <z-text-field
                        label="Optante do Simples"
                        readonly
                        :value="ordemservico.cliente.simples ? 'Sim' : 'Não'"
                      ></z-text-field>
                    </v-col>
                    <v-col sm="2">
                      <z-text-field
                        label="Retem ISS"
                        readonly
                        :value="ordemservico.cliente.retem_iss == 1 ? 'Sim' : 'Não'"
                      ></z-text-field>
                    </v-col>
                    <v-col sm="2">
                      <z-text-field
                        label="É MEI?"
                        readonly
                        :value="ordemservico.cliente.is_mei == 1 ? 'Sim' : 'Não'"
                      ></z-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- Tab 2: Competência e Local -->
            <v-tab-item eager>
              <v-card tile>
                <v-card-text>
                  <v-row dense>

                    <v-col sm="2">
                      <z-date-picker-menu
                        v-model="nfse.rps_data_emissao"
                        label="Data Emissão"
                        readonly
                      ></z-date-picker-menu>
                    </v-col>

                    <v-col sm="4">
                      <z-select
                        v-model="nfse.natureza_operacao"
                        :items="natureza_operacao"
                        label="Local"
                      ></z-select>
                    </v-col>

                    <v-col sm="2">
                      <z-select
                        v-model="nfse.servico.estado"
                        :items="estados"
                        label="Estado"
                        readonly
                      ></z-select>
                    </v-col>

                    <v-col sm="4">
                      <z-select
                        v-model="nfse.servico.codigo_municipio"
                        :items="getCidadesByUF(nfse.servico.estado)"
                        label="Cidade"
                        readonly
                      ></z-select>
                    </v-col>

                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- Tab 3: Serviço -->
            <v-tab-item eager>
              <v-card tile>
                <v-card-text>
                  <v-row dense>

                    <v-col sm="3">
                      <z-text-field
                        v-model="ordemservico.id"
                        label="Ordem de Serviço"
                        readonly
                      ></z-text-field>
                    </v-col>

                    <v-col sm="4">
                      <v-autocomplete
                        v-model="nfse.servico.codigo_servico"
                        v-bind="$v.TEXT_FIELDS"
                        :rules="[regras.obrigatorio]"
                        :items="lista_codigos_atividades"
                        item-text="codigo_servico"
                        item-value="codigo_servico"
                        label="Código Serviço"
                        @change="updateServico"
                      >
                        <template v-slot:item="{ item, attrs, on }">
                          <v-list-item dense v-bind="attrs" v-on="on">
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ item.descricao_completa }}
                              </v-list-item-title>
                              <v-list-item-subtitle>
                                 (Alíquota: {{ item.aliquota }}%)
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </v-col>

                    <v-col>
                      <v-row dense>
                        <v-col sm="6">
                          <z-campo-valor
                            v-model="nfse.servico.valores.aliquota"
                            label="Valor Alíquota"
                            suffix="%"
                            decimais="0"
                            :rules="[regras.obrigatorio]"
                            @input="calcularValores"
                          ></z-campo-valor>
                        </v-col>

                        <v-col sm="6">
                          <z-select
                            v-model="nfse.servico.valores.iss_retido"
                            :items="[{value: 1, text: 'Sim'}, {value: 2, text: 'Não'}]"
                            label="Iss retido"
                            @input="calcularValores"
                          ></z-select>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col sm="12">
                      <z-textarea
                        label="Discriminação"
                        v-model="nfse.servico.discriminacao"
                        :rules="[regras.obrigatorio]"
                      ></z-textarea>
                    </v-col>
                  </v-row>

                  <v-subheader>NBS/CBS/IBS</v-subheader>
                  <v-row dense>
                    <v-col sm="6">
                      <v-autocomplete
                        v-model="nfse.servico.nbs"
                        v-bind="$v.TEXT_FIELDS"
                        :rules="[regras.obrigatorio]"
                        :items="nbsItems"
                        item-text="descricao_completa"
                        item-value="nbs"
                        label="NBS"
                        @change="onChangeNbs"
                      ></v-autocomplete>
                    </v-col>
                    <v-col sm="6">
                      <v-autocomplete
                        v-model="nfse.servico.indop"
                        v-bind="$v.TEXT_FIELDS"
                        :rules="[regras.obrigatorio]"
                        :items="indopItems"
                        item-text="descricao_completa"
                        item-value="indop"
                        label="Código Indicador da Operação"
                        @change="onChangeIndop"
                      ></v-autocomplete>
                    </v-col>
                    <v-col sm="6">
                      <v-autocomplete
                        v-model="nfse.servico.cst"
                        v-bind="$v.TEXT_FIELDS"
                        :rules="[regras.obrigatorio]"
                        :items="cstItems"
                        item-text="descricao_completa"
                        item-value="cst"
                        label="Código de Situação Tributária - CST-IBS/CBS"
                        @change="onChangeCst"
                      ></v-autocomplete>
                    </v-col>
                    <v-col sm="6">
                      <v-autocomplete
                        v-model="nfse.servico.cclass_trib"
                        v-bind="$v.TEXT_FIELDS"
                        :rules="[regras.obrigatorio]"
                        :items="cclassTribItems"
                        item-text="descricao_completa"
                        item-value="cclass_trib"
                        label="Classificação Tributária"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- Tab 4: Valores -->
            <v-tab-item eager>
              <v-card tile>
                <v-card-title class="subtitle-2">
                  Valores
                </v-card-title>
                <v-card-text>
                  <v-row dense>

                    <v-col sm="3">
                      <z-campo-valor
                        v-model="nfse.servico.valores.valor_servicos"
                        label="Valor Serviço"
                        decimais="2"
                        :rules="[regras.maiorquezero]"
                        @input="calcularValores"
                      ></z-campo-valor>
                    </v-col>

                    <v-col sm="3">
                      <z-campo-valor
                        label="Valor Deduções"
                        v-model="nfse.servico.valores.valor_deducoes"
                        decimais="2"
                        @input="calcularValores"
                      ></z-campo-valor>
                    </v-col>

                    <v-col sm="3">
                      <z-campo-valor
                        v-model="nfse.servico.valores.desconto_incondicionado"
                        label="Desconto Incondicionado"
                        decimais="2"
                        @input="calcularValores"
                      ></z-campo-valor>
                    </v-col>

                    <v-col sm="3">
                      <z-campo-valor
                        v-model="nfse.servico.valores.desconto_condicionado"
                        label="Desconto Condicionado"
                        decimais="2"
                        @input="calcularValores"
                      ></z-campo-valor>
                    </v-col>

                    <v-col sm="3">
                      <z-campo-valor
                        v-model="nfse.servico.valores.outras_retencoes"
                        label="Valor Outras Retenções"
                        decimais="2"
                        @input="calcularValores"
                      ></z-campo-valor>
                    </v-col>

                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <!-- Tab 5: Impostos Federais -->
            <v-tab-item eager>
              <v-card tile>
                <v-card-title class="subtitle-2">
                  Impostos Federais
                </v-card-title>
                <v-card-text>
                  <v-row dense>

                    <v-col sm="3">
                      <z-campo-valor
                        v-model="nfse.servico.valores.valor_pis"
                        label="Pis"
                        decimais="2"
                        @input="calcularValores"
                      ></z-campo-valor>
                    </v-col>

                    <v-col sm="3">
                      <z-campo-valor
                        v-model="nfse.servico.valores.valor_cofins"
                        label="Cofins"
                        decimais="2"
                        @input="calcularValores"
                      ></z-campo-valor>
                    </v-col>

                    <v-col sm="3">
                      <z-campo-valor
                        v-model="nfse.servico.valores.valor_ir"
                        label="IR"
                        decimais="2"
                        @input="calcularValores"
                      ></z-campo-valor>
                    </v-col>

                    <v-col sm="3">
                      <z-campo-valor
                        v-model="nfse.servico.valores.valor_inss"
                        label="INSS"
                        decimais="2"
                        @input="calcularValores"
                      ></z-campo-valor>
                    </v-col>

                    <v-col sm="3">
                      <z-campo-valor
                        v-model="nfse.servico.valores.valor_csll"
                        label="CSLL"
                        decimais="2"
                        @input="calcularValores"
                      ></z-campo-valor>
                    </v-col>

                    <!-- <v-col sm="3">
                      <z-campo-valor
                        label="Valor ISS Retido"
                        v-model="nfse.servico.valores.iss_retido"
                        decimais="2"
                        readonly
                      ></z-campo-valor>
                    </v-col> -->
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>

          </v-tabs-items>
        </v-card>

        <v-card class="mb-5">
          <v-card-title class="subtitle-2">
            Valor Total
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col sm="3">
                <z-campo-valor
                  v-model="nfse.servico.valores.base_calculo"
                  label="Base de Cálculo"
                  decimais="2"
                  readonly
                ></z-campo-valor>
              </v-col>

              <v-col sm="3">
                <z-campo-valor
                  v-model="nfse.servico.valores.valor_liquido_nfse"
                  label="Valor líquido da nota"
                  decimais="2"
                  readonly
                ></z-campo-valor>
              </v-col>

              <v-col sm="3">
                <z-campo-valor
                  v-model="nfse.servico.valores.valor_iss"
                  label="Valor do ISS a pagar"
                  decimais="2"
                  readonly
                ></z-campo-valor>
              </v-col>

              <!-- <v-col sm="3">
                <z-campo-valor label="Valor ISS Retido" v-model="nfse.servico.valores.valor_iss_retido" decimais="2" readonly></z-campo-valor>
              </v-col> -->

            </v-row>
          </v-card-text>
        </v-card>

        <z-dev v-if="false">
          <v-card tile class="mb-5">
            <v-card-title class="subtitle-2">
              Valores
            </v-card-title>
            <v-card-text>
              <v-row dense>

                <v-col sm="3">
                  <z-campo-valor
                    v-model="nfse.servico.valores.valor_servicos"
                    label="Valor Serviço"
                    decimais="2"
                    :rules="[regras.maiorquezero]"
                    :readonly="!isNotaAvulsa"
                    @input="calcularValores"
                  ></z-campo-valor>
                </v-col>

                <v-col sm="3">
                  <z-campo-valor
                    v-model="nfse.servico.valores.valor_deducoes"
                    label="Valor Deduções"
                    decimais="2"
                    @input="calcularValores"
                  ></z-campo-valor>
                </v-col>

                <v-col sm="3">
                  <z-campo-valor
                    v-model="nfse.servico.valores.desconto_incondicionado"
                    label="Desconto Incondicionado"
                    decimais="2"
                    @input="calcularValores"
                  ></z-campo-valor>
                </v-col>

                <v-col sm="3">
                  <z-campo-valor
                    v-model="nfse.servico.valores.desconto_condicionado"
                    label="Desconto Condicionado"
                    decimais="2"
                    @input="calcularValores"
                  ></z-campo-valor>
                </v-col>

                <v-col sm="3">
                  <z-campo-valor
                    v-model="nfse.servico.valores.outras_retencoes"
                    label="Valor Outras Retenções"
                    decimais="2"
                    @input="calcularValores"
                  ></z-campo-valor>
                </v-col>

              </v-row>
            </v-card-text>
          </v-card>
          <v-card tile class="mb-5">
            <v-card-title class="subtitle-2">
              Impostos Federais
            </v-card-title>
            <v-card-text>
              <v-row dense>

                <v-col sm="3">
                  <z-campo-valor
                    v-model="nfse.servico.valores.valor_pis"
                    label="Pis"
                    decimais="2"
                    @input="calcularValores"
                  ></z-campo-valor>
                </v-col>

                <v-col sm="3">
                  <z-campo-valor
                    v-model="nfse.servico.valores.valor_cofins"
                    label="Cofins"
                    decimais="2"
                    @input="calcularValores"
                  ></z-campo-valor>
                </v-col>

                <v-col sm="3">
                  <z-campo-valor
                    v-model="nfse.servico.valores.valor_ir"
                    label="IR"
                    decimais="2"
                    @input="calcularValores"
                  ></z-campo-valor>
                </v-col>

                <v-col sm="3">
                  <z-campo-valor
                    v-model="nfse.servico.valores.valor_inss"
                    label="INSS"
                    decimais="2"
                    @input="calcularValores"
                  ></z-campo-valor>
                </v-col>

                <v-col sm="3">
                  <z-campo-valor
                    v-model="nfse.servico.valores.valor_csll"
                    label="CSLL"
                    decimais="2"
                    @input="calcularValores"
                  ></z-campo-valor>
                </v-col>

                <!-- <v-col sm="3">
                  <z-campo-valor label="Valor ISS Retido" v-model="nfse.servico.valores.iss_retido" decimais="2" readonly></z-campo-valor>
                </v-col> -->
              </v-row>
            </v-card-text>
          </v-card>
        </z-dev>

        <v-container fluid class="pt-0">

          <v-row dense>
            <v-col sm="12">

              <v-alert color="error" :icon="$icon.ALERTA" v-if="nfse.retorno_codigo || nfse.retorno_mensagem || nfse.retorno_correcao" dense outlined>
                <div v-if="nfse.retorno_codigo"><b>Código Erro: </b> {{ nfse.retorno_codigo }}</div>
                <div v-if="nfse.retorno_mensagem"><b>Mensagem: </b> {{ nfse.retorno_correcao }}</div>
                <div v-if="nfse.erro"><b>Erro: </b> {{ nfse.erro }}</div>
                <div v-if="nfse.retorno_correcao"><b>Correção: </b> {{ nfse.retorno_mensagem }}</div>
              </v-alert>

            </v-col>
          </v-row>

        </v-container>


        <!-- <v-subheader>Intermediário Serviço</v-subheader>
        <v-divider></v-divider>

        <v-container fluid grid-list-md>
          <v-row>

            <v-col sm="4">
              <v-text-field label="Razão Social" v-model="nfse.intermediario_servico.razao_social" readonly></v-text-field>
            </v-col>

            <v-col sm="4">
              <v-text-field label="CNPJ" v-model="nfse.intermediario_servico.cnpj" readonly></v-text-field>
            </v-col>

            <v-col sm="4">
              <v-text-field label="Inscrição Municipal" v-model="nfse.intermediario_servico.inscricao_municipal" readonly></v-text-field>
            </v-col>


          </v-row>
        </v-container>

        <v-subheader>Construção Civil</v-subheader>
        <v-divider></v-divider>

        <v-container fluid grid-list-md>
          <v-row>

            <v-col sm="4">
              <v-text-field label="Código de Obra" v-model="nfse.construcao_civil.razao_social" readonly></v-text-field>
            </v-col>

            <v-col sm="4">
              <v-text-field label="Art" v-model="nfse.construcao_civil.art" readonly></v-text-field>
            </v-col>

          </v-row>
        </v-container> -->


      </z-container>

    </v-form>

    <ProcessoEmissaoDialog ref="dialogoProcessoEmissao" :nota="nfse"></ProcessoEmissaoDialog>
    <dialogo-buscar-clientes ref="DialogoBuscarClientes" @busca:selecionar="setTomador"></dialogo-buscar-clientes>
  </div>
</template>

<script>
  // import '@/components/buscas.js';
  import { mapStores } from 'pinia'
  // import {mapState, mapActions} from 'vuex'
  import { natureza_operacao, regime_especial_tributacao } from "./aux/codigos.js";
  import aliquotas from "./aux/aliquotas.js";
  import globals from '@/app/globals.js';
  import dayjs from 'dayjs'
  import { dataBR, valorBR, onlyNumbers, valorUS } from '@/app/helpers/formatacoes.js'
  import notaFiscaisApi from '@/app/services/notasfiscais.js'
  import emitentesApi from "@/app/services/emitentes.js"
  import { useClassificacaoTributariaStore } from '@/app/store/pinia/classificacaoTributaria'

  import ProcessoEmissaoDialog from "./ProcessoEmissaoDialog.vue"

  export default {
    name: 'NotasFiscaisForm',

    components: {
      ProcessoEmissaoDialog,
    },

    data() {
      return {
        emitente: {},
        loadingList: false,
        form_valido: true,
        globals,
        aliquotas,
        cidades_nfse: [],
        codigo_servico: {
          codigo_servico: '1.03/631190001',
          descricao: '',
          aliquota: 2,
        },
        natureza_operacao: natureza_operacao,
        regime_especial_tributacao: regime_especial_tributacao,
        nfse: {
          emitente_id: null,
          emitente_cnpj: null,
          rps_situacao: 1,
          retorno_codigo: null,
          retorno_correcao: null,
          retorno_mensagem: null,

          numero: 1234,
          serie: 1,
          tipo:1,

          rps_data_emissao: dayjs().format("YYYY-MM-DD"),
          natureza_operacao: 1,
          // 1 – Tributação no município
          // 2 - Tributação fora do município
          // 3 - Isenção
          // 4 - Imune
          // 5 – Exigibilidade suspensa por decisão judicial
          // 6 – Exigibilidade suspensa por procedimento administrativo

          regime_especial_tributacao: 5,
          // 1 – Microempresa municipal
          // 2 - Estimativa
          // 3 – Sociedade de profissionais
          // 4 – Cooperativa
          // 5 – MEI – Simples Nacional
          // 6 – ME EPP – Simples Nacional

          optante_simples_nacional: 1,
          incentivador_cultural: 2,
          status: 1,

          tomador: {
            cpfcnpj: '',
            razao_social: '',
            endereco: '',
            numero: '',
            complemento: '',
            bairro: '',
            codigo_municipio: '',
            uf: '',
            cep: '',
            email: '',
            telefone: '',
            id: null,
          },

          servico: {

            codigo_servico: "1.03/631190001",
            item_lista_servico: "1.03",
            codigo_tributacao_municipio: "631190001",
            discriminacao: "",
            codigo_municipio: "2604106",
            estado: 'PE',
            nbs: '',
            indop: '',
            cst: '',
            cclass_trib: '',

            valores: {
              valor_servicos: 0.00,
              desconto_incondicionado: 0.00,
              desconto_condicionado: 0.00,
              valor_deducoes: 0.00,
              valor_pis: 0.00,
              valor_cofins: 0.00,
              valor_inss: 0.00,
              valor_ir: 0.00,
              valor_csll: 0.00,
              iss_retido: 2,
              valor_iss: 0.00,
              valor_iss_retido: 0.00,
              outras_retencoes: 0.00,
              base_calculo: 0.00,
              aliquota: 5,
              valor_liquido_nfse: 0.00
            }
          },

          intermediario_servico: {
            razao_social: 'INSCRICAO DE TESTE SIATU - D AGUA -PAULINO S',
            cnpj: '99999999000191',
            inscricao_municipal: '8041700010'
          },

          construcao_civil: {
            codigo_obra: '1234',
            art: '1234'
          }

        },

        emitindo: false,
        regras: {
          obrigatorio: v => !!v || 'Campo obrigatório',
          cnpj: v => !!v.cnpj || 'CPF/CNPJ obrigatório',
          maiorquezero: v => valorUS(v) > 0 || 'O valor é orbigatório'
        },
        from_route: {
          name: ''
        },

        salvando: false,
        exibir_alerta_formulario: false,
        tabAtiva: null,
      }
    },

    computed: {
      ...mapStores(useClassificacaoTributariaStore),

      ordemservico() {
        return this.$store.state.ordemservico.ordemservico;
      },

      nbsItems() {
        return this.classificacaoTributariaStore.nbs;
      },

      indopItems() {
        return this.classificacaoTributariaStore.indops;
      },

      cstItems() {
        return this.classificacaoTributariaStore.csts;
      },

      cclassTribItems() {
        return this.classificacaoTributariaStore.classificacoes;
      },

      lista_codigos_atividades() {
        return aliquotas.map(item => {
          return {
            codigo_servico: `${item.codigo_servico}/${item.codigo_atividade}`,
            descricao: item.descricao_servico,
            aliquota: item.aliquota,
            descricao_completa: `${item.codigo_servico}/${item.codigo_atividade} - ${item.descricao_servico}`
          };
        })
      },

      estados() {
        return this.$store.state.listas.estados.map(estado => {
          return estado.sigla
        });
      },

      emitentes() {
        return this.$store.state.listas.clientes.map(emitente => {
          return {
            'text': emitente.nome,
            'value': emitente.id,
            ...emitente
          }
        })
      },

      isAdicionando() {
        return this.$route.name == 'NotasFiscaisAdicionar';
      },

      isEditando() {
        return this.$route.name == 'NotasFiscaisEditar';
      },

      isNotaAvulsa() {
        return this.$route.name == 'NotaServicoAvulsa';
      }
    },

    watch: {
      $route: {
        immediate: true,
        async handler(to, from) {
          this.form_valido = true;
          this.exibir_alerta_formulario = false;
          await this.carregarEmitente();

          if (to.params.id && to.name == 'NotasFiscaisEditar') {
            await this.$store.dispatch('notasfiscais/abrirNotaFiscal', to.params.id);
            this.nfse = { ...this.$store.state.notasfiscais.notafiscal };
            this.normalizarCamposClassificacaoTributaria();
          }

          if (to.name == 'NotasFiscaisAdicionar' && to.query.ordemservico_id) {
            await this.$store.dispatch('ordemservico/abrir', to.query.ordemservico_id);
            this.preencherNotaFiscal(this.ordemservico);
            this.normalizarCamposClassificacaoTributaria();
          }

          await this.carregarClassificacaoOptionsIniciais();
        }
      },
      nfse: {
        deep: true,
        handler() {
          if (this.exibir_alerta_formulario) {
            this.exibir_alerta_formulario = false;

            this.$nextTick(() => {
              if (this.$refs.form) {
                this.$refs.form.resetValidation();
              }
            });
          }
        }
      },
    },

    async mounted () {
      this.init();
    },

    methods: {
      async init() {
        this.loadingList = true;
        await this.carregarEstados();
        await this.classificacaoTributariaStore.carregarNbs(this.nfse.servico.codigo_servico);
        this.loadingList = false;
      },

      normalizarCamposClassificacaoTributaria() {
        if (!this.nfse.servico) {
          this.nfse.servico = {};
        }

        this.nfse.servico.nbs = this.nfse.servico.nbs || '';
        this.nfse.servico.indop = this.nfse.servico.indop || '';
        this.nfse.servico.cst = this.nfse.servico.cst || '';
        this.nfse.servico.cclass_trib = this.nfse.servico.cclass_trib || '';
      },

      async carregarClassificacaoOptionsIniciais() {
        this.classificacaoTributariaStore.limpar();
        await this.classificacaoTributariaStore.carregarNbs(this.nfse.servico.codigo_servico);

        if (this.nfse.servico.nbs) {
          await this.classificacaoTributariaStore.carregarIndops(this.nfse.servico.nbs);
        }

        if (this.nfse.servico.nbs && this.nfse.servico.indop) {
          await this.classificacaoTributariaStore.carregarCsts({
            nbs: this.nfse.servico.nbs,
            indop: this.nfse.servico.indop,
          });
        }

        if (this.nfse.servico.nbs && this.nfse.servico.indop && this.nfse.servico.cst) {
          await this.classificacaoTributariaStore.carregarClassificacoes({
            nbs: this.nfse.servico.nbs,
            indop: this.nfse.servico.indop,
            cst: this.nfse.servico.cst,
          });
        }
      },

      async onChangeNbs() {
        this.nfse.servico.indop = '';
        this.nfse.servico.cst = '';
        this.nfse.servico.cclass_trib = '';

        await this.classificacaoTributariaStore.carregarIndops(this.nfse.servico.nbs);
      },

      async onChangeIndop() {
        this.nfse.servico.cst = '';
        this.nfse.servico.cclass_trib = '';

        await this.classificacaoTributariaStore.carregarCsts({
          nbs: this.nfse.servico.nbs,
          indop: this.nfse.servico.indop,
        });
      },

      async onChangeCst() {
        this.nfse.servico.cclass_trib = '';

        await this.classificacaoTributariaStore.carregarClassificacoes({
          nbs: this.nfse.servico.nbs,
          indop: this.nfse.servico.indop,
          cst: this.nfse.servico.cst,
        });
      },

      async carregarEmitente(emitente) {
        try {
          const response = await emitentesApi.emitente();
          this.emitente = response.data;
          this.setEmitente(this.emitente);
        } catch (error) {
          if (error.response && error.response.status === 404) {
            this.limparForm();
          }
        }
      },

      async emitirNFSE() {
        if (!this.$refs.form.validate()) {
          this.exibir_alerta_formulario = true;
          return false;
        }

        this.exibir_alerta_formulario = false;

        await this.salvarNFSE();
        this.$refs.dialogoProcessoEmissao.abrir();
      },

      async salvarNFSE() {
        if (!this.$refs.form.validate()) {
          this.exibir_alerta_formulario = true;
          return false;
        }

        this.exibir_alerta_formulario = false;

        try {
          this.salvando = true;
          if (this.nfse.id) {
            await notaFiscaisApi.update(this.nfse);
          } else {
            const nota = await notaFiscaisApi.store(this.nfse);

            if (!nota.id) {
              this.$router.push({ name: 'NotasFiscaisLista' })
            }

            this.$router.push({ name: 'NotasFiscaisEditar', params: { id: nota.id } })
          }

          // this.$router.push({ name: 'NotasFiscaisLista' })

        } catch (error) {
          throw error;
        } finally {
          this.salvando = false;
        }
      },

      preencherNotaFiscal(ordemservico) {
        this.nfse.servico_id                          = ordemservico.id;
        this.nfse.servico.item_lista_servico          = "1.03";
        this.nfse.servico.codigo_tributacao_municipio = "631190001";
        this.nfse.servico.discriminacao               = "Prestação de serviço de valor adicionado SVA.";
        this.nfse.servico.codigo_municipio            = this.emitente.codigo_municipio;

        this.nfse.tomador = {
          id: ordemservico.cliente.id,
          cpfcnpj: ordemservico.cliente.cpf_cnpj,
          razao_social: ordemservico.cliente.nome,
          endereco: ordemservico.cliente.endereco,
          numero: ordemservico.cliente.numero,
          complemento: ordemservico.cliente.ponto_referencia,
          bairro: ordemservico.cliente.bairro,
          codigo_municipio: ordemservico.cliente.codigo_municipio,
          uf: ordemservico.cliente.estado,
          cep: ordemservico.cliente.cep,
          email: ordemservico.cliente.email,
          telefone: ordemservico.cliente.telefone,
          is_mei: ordemservico.cliente.is_mei
        }

        this.nfse.servico.valores.valor_servicos          = ordemservico.total_servicos;
        this.nfse.servico.valores.desconto_incondicionado = 0;
        this.nfse.servico.valores.desconto_condicionado   = 0;
        this.nfse.servico.valores.valor_deducoes          = 0;
        this.nfse.servico.valores.iss_retido              = ordemservico.cliente.retem_iss == 1 ? 1 : 2;
        this.nfse.servico.valores.base_calculo            = ordemservico.total_servicos;

        this.calcularValores();
      },

      setHTMLOverflowYVisible(state = true) {
        let html = document.querySelector("html");
        html.style.overflowY = state == false ? "hidden" : "";
      },

      getCidadesByUF(sigla) {
        if (sigla) {
          const estado = this.$store.state.listas.estados.find(estado => estado.sigla == sigla);

          if (estado) {
            return estado.cidades.map(cidade => {
              return {
                'text': cidade.nome.toUpperCase(),
                'value': cidade.codigo
              }
            })
          }
        }

        return [];
      },


      setDiscriminacaoNFSE() {
        console.log(this.nfse.servico.valores.valor_liquido_nfse, this.emitente.ibpt);
        const ordemservico_id = this.nfse.servico_id || this.ordemservico.id;
        const valor_ibpt = valorBR((this.nfse.servico.valores.valor_liquido_nfse * this.emitente.ibpt) / 100);
        this.nfse.servico.discriminacao = [
          'Prestação de serviço de valor adicionado SVA.',
          `Prestação de serviço de oficina mecânica referente à Ordem de Serviço Nº ${ordemservico_id}.`,
          `Valor aproximado dos tributos R$ ${valor_ibpt} Fonte: (IBPT)`
        ].join('\n');

      },

      onChangeEmitente(emitente) {
        this.nfse.emitente_id = emitente.value;
        this.nfse.emitente_cnpj = emitente.cnpj;
        // this.setDiscriminacaoNFSE(this.fatura);
      },

      setEmitente(emitente) {
        this.nfse.emitente_id = emitente.id;
        this.nfse.emitente_cnpj = emitente.cnpj;
        this.nfse.emitente_razao_social = emitente.razao;
      },

      calcularValores() {
        console.log('calcularValores');

        const valores = this.nfse.servico.valores;

        valores.base_calculo = valores.valor_servicos;
        valores.valor_liquido_nfse = valores.valor_servicos;

        valores.base_calculo = valores.base_calculo - valores.valor_deducoes;
        valores.base_calculo = valores.base_calculo - valores.desconto_incondicionado;

        valores.valor_liquido_nfse = valores.valor_liquido_nfse - valores.desconto_incondicionado;
        valores.valor_liquido_nfse = valores.valor_liquido_nfse - valores.desconto_condicionado;
        valores.valor_liquido_nfse = valores.valor_liquido_nfse - valores.outras_retencoes;

        valores.valor_liquido_nfse = valores.valor_liquido_nfse - valores.valor_pis;
        valores.valor_liquido_nfse = valores.valor_liquido_nfse - valores.valor_cofins;
        valores.valor_liquido_nfse = valores.valor_liquido_nfse - valores.valor_inss;
        valores.valor_liquido_nfse = valores.valor_liquido_nfse - valores.valor_ir;
        valores.valor_liquido_nfse = valores.valor_liquido_nfse - valores.valor_csll;

        valores.valor_iss = valores.base_calculo * (valores.aliquota/100);
        if (this.nfse.servico.valores.iss_retido == 1) {
            valores.valor_liquido_nfse = valores.valor_liquido_nfse - valores.valor_iss;
            valores.valor_iss_retido = valores.valor_iss;
        } else {
          valores.valor_iss_retido = null;
        }


        if (this.nfse.tomador.is_mei == 1) {
          console.log('Tomador é MEI, ISS = 0');
          // valores.valor_iss = 0.00;
          valores.valor_liquido_nfse = valores.valor_liquido_nfse - valores.valor_iss;
          valores.valor_iss_retido = 0.00;
          this.nfse.servico.valores.iss_retido = 2;
        }

        this.setDiscriminacaoNFSE();
      },

      voltar() {
        if (this.$route.name == 'NovaNotaServico') {
          this.$router.push({name: 'FaturamentoLista'});
        } else {
          this.$router.push({name: 'NotasFiscaisLista'});
        }
      },

      async buscarTomador(event) {
        // if (this.isEditando || this.isAdicionando) {
        //   return false;
        // }

        // const cpfcnpj = onlyNumbers(event.target.value);
        const cpfcnpj = (event.target.value);
        if (cpfcnpj.length == 14 || cpfcnpj.length == 18) {
          await this.$store.dispatch('notasfiscais/getTomador', cpfcnpj);
          const tomador = this.$store.state.notasfiscais.tomador;

          this.setTomador(tomador);
        }
      },

      setTomador(tomador) {

        console.log("setTomador", tomador);

        this.nfse.tomador = {
          id: tomador.id,
          cpfcnpj: tomador.cpf_cnpj,
          razao_social: tomador.nome,
          endereco: tomador.endereco,
          numero: tomador.numero,
          complemento: tomador.ponto_referencia,
          bairro: tomador.bairro,
          codigo_municipio: tomador.codigo_municipio,
          uf: tomador.estado,
          cep: tomador.cep,
          email: tomador.email,
          telefone: tomador.telefone,
        }
      },

      async carregarEstados() {
        console.log("Carregar estados");
        this.$store.dispatch('listas/estados');

        // const dia = 1;
        // const estados = await this.$storage.remember('estados', dia * 1, () => {
        //   console.log("Rodou callback cache");
        //   this.$store.dispatch('listas/estados');
        //   return this.$store.state.listas.estados;
        // });
      },

      async updateServico() {
        const [item_lista_servico, codigo_tributacao_municipio] = this.nfse.servico.codigo_servico.split('/');
        this.nfse.servico.item_lista_servico = item_lista_servico;
        this.nfse.servico.codigo_tributacao_municipio = codigo_tributacao_municipio;

        this.nfse.servico.nbs = '';
        this.nfse.servico.indop = '';
        this.nfse.servico.cst = '';
        this.nfse.servico.cclass_trib = '';

        await this.classificacaoTributariaStore.carregarNbs(this.nfse.servico.codigo_servico);
      }

    },


  }
</script>

<style scoped>

</style>
